import TableEmptyRow from 'components/others/TableEmptyRow';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestDraftItem } from '../model/types';
import RequestItemsTableRow from './RequestItemsTableRow';

interface RequestItemsTableBodyProps {
    items: SupplierRequestDraftItem[];
    editCountIndex: number | null;
    setEditCountIndex: (index: number | null) => void;
    onSaveCount: (index: number, value: string | number) => void;
    onRemove: (index: number) => void;
    disabled?: boolean;
    showActions?: boolean;
    showReceived?: boolean;
}
 
const RequestItemsTableBody = ({
    items,
    editCountIndex,
    setEditCountIndex,
    onSaveCount,
    onRemove,
    disabled = false,
    showActions = true,
    showReceived = false,
}: RequestItemsTableBodyProps) => {
    const { t } = useTranslation(['Vendors']);
    const colSpan = 5 + (showReceived ? 1 : 0) + (showActions ? 1 : 0);

    if (!items.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={colSpan}>
                    <span className="text-muted">{t('supplierRequests.create.emptyItems')}</span>
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {items.map((item, index) => (
                <RequestItemsTableRow
                    key={`${item.productId}-${item.objectId || 0}-${index}`}
                    item={item}
                    index={index}
                    editCountIndex={editCountIndex}
                    setEditCountIndex={setEditCountIndex}
                    onSaveCount={onSaveCount}
                    onRemove={onRemove}
                    disabled={disabled}
                    showActions={showActions}
                    showReceived={showReceived}
                />
            ))}
        </tbody>
    );
};

export default RequestItemsTableBody;
